// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__32DGh","calendarButtons":"ClockData_calendarButtons__2-hWB"};